<template>
  <div class="header">
    <div class="logo mini">
    </div>
  </div>
</template>

<script>

import ChangePwPop from '@/components/ChangePwPop.vue';
import PopDocReadPop from '@/components/Bbs/PopDocRead2.vue';

export default {
  name: 'Navbar',
  props: {
    msg: String,
  },

  data() {
    return {
        authority:"",
        banners: [{
          key: '01',
          value: 'first'
        },{
          key: '02',
          value: 'second'
        },{
          key: '03',
          value: 'third'
        }]
    };
  },
  computed:{
    classObj() {
      return {
        'navbar-item': true,
        'is-hoverable': true,
      }
    },
  },
  mounted() {
    console.log('this msg: ', this.msg);
  },

  methods: {
    logout() {
      this.$http
        .get('/api/logout')
        .then(() => {
          this.$store.commit('logout');
          this.$cookie.delete('loginInfo');
          this.$router.push({path: `/login`}).catch(()=>{});
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
        });
    },
    changePwPop(){
      // eslint-disable-next-line no-unused-vars
      let vm = this
      
      this.$modal.open({
          component: ChangePwPop,
          // props: {
          //   param: this.string
          // },
          parent: this,
          width: 500,
          events: {
              // eslint-disable-next-line no-unused-vars
              close(value) {
              }
          }
      }) 
    },
    mainMenuAction(){
      if ($(".lnb").hasClass("minimized")) {
        $(".lnb").removeClass("minimized");
        $(".header > .logo").removeClass("mini");
        $(".header .logo > a > img.logo-big").css("display", "inline-block");
        $(".header .logo > a > img.logo-mini").css("display", "none");
        $("#btnLnb").attr("title", "접기");
        
        $(".header > .logo").removeClass("mini");
        if ($(".menu-depth01 > li").hasClass("hide")) {
            $(".menu-depth01 > li.open").removeClass("hide");
            //토글 상태 초기화
            if ($(".menu-depth01 > li.open > .menu-depth02").css("display", "none")) {
                $(".menu-depth01 > li.open > .menu-depth02").css("display", "block");
            } else {
                $(".menu-depth01 > li.open > .menu-depth02").css("display", "none");
            }
            $(".menu-depth01 > li.open > .menu-depth02").css("display", "none");
            $(".menu-depth01 > li.open > .menu-depth02").toggle();
        }
      } else {
          $(".lnb").addClass("minimized");
          $(".header > .logo").addClass("mini");
          $(".header .logo > a > img.logo-big").css("display", "none");
          $(".header .logo > a > img.logo-mini").css("display", "inline-block");
          $("#btnLnb").attr("title", "펼치기");

          if ($(".menu-depth01 > li").hasClass("open")) {
              $(".menu-depth01 > li.open").addClass("hide");
              //토글 상태 초기화
              if ($(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block")) {
                  $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "none");
              } else {
                  $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block")
              }
              $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block");
              $(".menu-depth01 > li.open.hide > .menu-depth02").toggle();
          }
      }
    },
    getNotices() {
      const {asAgentId, compCd} = this.$store.state.loginInfo;
      if( asAgentId && compCd ) {
        this.$store.commit('loading');
        this.$http.post(`/api/boardMng/notice/list`,{
          companyId: this.$store.state.loginInfo.compCd,
          srcId1: 'Home',
          srcId2: 'Notice',
          srcId3: "",
          srcId4: "",
          searchType: "",
          searchTxt: "",
          startDt: this.$moment(new Date()).format('YYYY-MM-DD'),
          endDt: this.$moment(new Date()).format('YYYY-MM-DD'),
          asAgentId: this.$store.state.loginInfo.asAgentId,
          sortType : "",
          page : 1,
          totalPage : 5,
          totalCount : 1,
          curPage : 1,
          processTime : ""
        })
        .then(response => {
            this.banners = response.data;
        }).finally(() => {
          this.$store.commit('finish');
        });
      } else {
        this.banners = [];
      }
    },
    noticePopModal(item) {
      this.$modal.open({
          component: PopDocReadPop,
          props: {
            custParam: item,
            title: `공지사항`
          },
          parent: this,
          width: 500,
          events: {
              // eslint-disable-next-line no-unused-vars
              close(value) {
              }
          }
      }) 
    }
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/common";

.spacer {
  width: 80px;
}

.navbar {
  background-color: $green;
  font-weight: bold;
}
</style>
